import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import CustomPieChart from "../../../../Common/Components/Charts/PieChart";
import CircularProgress from "../../../../Common/Components/CircularLoader";
import SelectPopover from "../../../../Common/Components/SelectPopover";
import axiosMain from "../../../../http/axiosMain";

const getEngagementChartData = (data) => {
  return [
    { name: "Likes", value: data?.likes || 0, fill: "#FDD5DC" },
    { name: "Comments", value: data?.comments || 0, fill: "#B3EBE8" },
    { name: "Saves", value: data?.saves || 0, fill: "#D0FCD7" },
    { name: "Shares", value: data?.shares || 0, fill: "#B9F3FC" },
  ];
};

const Engagement = ({ campaigns, loading }) => {
  const [engagementLoading, setEngagementLoading] = useState(true);
  const [engagementInsights, setEngagementInsights] = useState({});
  const [selectedCampaign, setSelectedCampaign] = useState(null);

  const getInstagramEngagement = async (campaignDetails) => {
    try {
      setEngagementLoading(true);
      const resp = await axiosMain.get("api/v1/insights/instagram-engagement");
      if (resp.status === 200 && resp.data?.success) {
        setEngagementInsights(resp.data?.data || {});
      } else {
        toast.error(resp.data?.message || "Something went wrong", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message || err?.message || "Something went wrong",
        {
          position: "top-right",
          autoClose: 3000,
        }
      );
    } finally {
      setEngagementLoading(false);
    }
  };

  useEffect(() => {
    if (selectedCampaign?.campaign_id) getInstagramEngagement(selectedCampaign);
  }, [selectedCampaign]);

  useEffect(() => {
    if (!loading) {
      if (campaigns.length) setSelectedCampaign(campaigns[0]);
      else {
        setEngagementLoading(false);
        setEngagementInsights({
          likes: 6000,
          comments: 8000,
          saves: 4000,
          shares: 3000,
        });
      }
    }
  }, [campaigns, loading]);

  return (
    <div className="instagram-container">
      <div className="options-content">
        <span className="platformtitle card-title">Engagement</span>
        {campaigns.length ? (
          <SelectPopover
            options={campaigns
              .filter((i) => i.campaign_title)
              .map((i) => ({ ...i, label: i.campaign_title }))}
            onChange={(value) => {
              setSelectedCampaign(value);
            }}
          >
            <div className="right-top-actions">
              <span>{selectedCampaign?.campaign_title}</span>
              <ExpandMoreRoundedIcon sx={{ width: "20px" }} />
            </div>
          </SelectPopover>
        ) : (
          <></>
        )}
      </div>
      {!engagementLoading &&
      !loading &&
      Object.keys(engagementInsights || {}).length ? (
        <>
          <div className="pie-chart">
            <CustomPieChart
              width={332}
              height={332}
              data={getEngagementChartData(engagementInsights || {})}
              innerRadius={60}
              centerLabel={{
                title: "Audience Engaged",
                value: "4%",
              }}
            />
          </div>
        </>
      ) : engagementLoading || loading ? (
        <CircularProgress
          containerStyle={{
            minHeight: "332px",
          }}
        />
      ) : (
        <div className="no-data">
          <small>No Data Found.</small>
        </div>
      )}
    </div>
  );
};

export default Engagement;
